import styled from 'styled-components';
import { media, mixins, fonts } from '@custom-components';

export const Content = styled.div`
  font-family: ${fonts.fontRegular} !important;
  padding-top: ${mixins.pxToRem(10)};
  ${media.greaterThan('lg')`
  max-width: ${mixins.pxToRem(900)};
`};
`;

export const SpinnerWrapper = styled.div`
  padding-top: ${mixins.pxToRem(15)};
  position: 'fixed';
  background-color: '#ffffff7d';
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;
